// Initial state
function initialState() {
	return {
		rightRX: {},
		leftRX: {}
	}
}

const state = initialState()

// Getters
const getters = {
	rightRX: (state) => {
		return state.rightRX
	},
	leftRX: (state) => {
		return state.leftRX
	},
	// Separate getters for sending to the DB that has prisms & directions converted to positive/negative numbers
	rightRXDB: (state) => {
		let tempRight = Object.assign({}, state.rightRX)
		if (tempRight.vPrismDirection == "down") {
			tempRight.vPrism = 0-tempRight.vPrism
		}
		delete tempRight.vPrismDirection
		if (tempRight.hPrismDirection == "out") {
			tempRight.hPrism = 0-tempRight.hPrism
		}
		delete tempRight.hPrismDirection
		return tempRight
	},
	leftRXDB: (state) => {
		let tempLeft = Object.assign({}, state.leftRX)
		if (tempLeft.vPrismDirection == "down") {
			tempLeft.vPrism = 0-tempLeft.vPrism
		}
		delete tempLeft.vPrismDirection
		if (tempLeft.hPrismDirection == "out") {
			tempLeft.hPrism = 0-tempLeft.hPrism
		}
		delete tempLeft.hPrismDirection
		return tempLeft
	}
}

// Actions
const actions = {
	resetState ({ state, commit }) {
		commit('reset')
	},
	addRightRX ({ state, commit }, RX) {
		commit('setRightRX', RX)
	},
	addLeftRX ({ state, commit }, RX) {
		commit('setLeftRX', RX)
	},
	deleteRightRX ({ state, commit }) {
		commit('setRightRX', {})
	},
	deleteLeftRX ({ state, commit }) {
		commit('setLeftRX', {})
	}
}

// Mutations
const mutations = {
	reset (state) {
		// acquire initial state
		const s = initialState()
		Object.keys(s).forEach(key => {
			state[key] = s[key]
		})
	},
	setRightRX (state, RX) {
		state.rightRX = RX
	},
	setLeftRX (state, RX) {
		state.leftRX = RX
	}
}

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations
}
